module.exports = __webpack_public_path__ + "static/media/super_pack_en_hiver_chat.29abf359.png";